import React from 'react';
import styled from '@emotion/styled';
import Icon from '~ComponentsImproved/Icon';
import closeIcon from '~Assets/icons/close.svg';

const Wrapper = styled.div`
  width: 40px;
  height: 40px;
  border: 1px solid #ffffff;
  border-radius: 50%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`;

interface Props {
  onClick: () => void;
}

const CloseButton = ({ onClick }: Props) => {
  return (
    <Wrapper onTouchStart={onClick}>
      <Icon src={closeIcon} />
    </Wrapper>
  );
};

export default CloseButton;
